// Communications tab — the Inbox's conversation, inside the customer window.
// Same component as the Inbox thread pane (ConversationThread): conversation
// first, composer at the bottom, calls rendered as calls. Nothing is re-implemented
// here; this file only works out who the conversation is with.
import React, { useMemo } from "react";
import ConversationThread from "../../Communications/Inbox/ConversationThread";
import "./CommunicationsTab.css";

export default function CommunicationsTab({ lead, customer, initialChannel }) {
  const partyUID =
    lead?.universal_id || lead?.raw?.universal_id || customer?.universal_id || customer?.raw?.universal_id || null;
  const leadId = lead?.object === "lead" ? lead.id : null;
  const customerId =
    lead?.object === "customer" ? lead.id
      : lead?.object === "revival" ? lead.customer_id
        : customer?.id || customer?.customer_id || null;

  const target = useMemo(
    () => ({ party_universal_id: partyUID || undefined, lead_id: leadId || undefined, customer_id: customerId || undefined }),
    [partyUID, leadId, customerId]
  );
  const contact = useMemo(() => {
    const src = lead?.raw || lead || customer?.raw || customer || {};
    return {
      name: src.display_name || src.name || [src.first_name, src.last_name].filter(Boolean).join(" "),
      phone: src.primary_phone || src.phone_number || src.phone || "",
      email: src.primary_email || src.email || src.secondary_email || "",
    };
  }, [lead, customer]);

  return (
    <div className="ctab">
      <ConversationThread target={target} contact={contact} initialChannel={initialChannel} />
    </div>
  );
}
